'use client';

import { useTheme } from "next-themes";
import Image from "next/image";
import { useRouter } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';
import { SidebarContext } from "@/components/ui/sidebar";

export function ThemeLogo() {
  const { theme, systemTheme } = useTheme();
  const router = useRouter();
  const { collapsed } = useContext(SidebarContext);
  const [mounted, setMounted] = useState(false);
  
  // Wait until mounted to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  // Default to light theme during SSR to match server render
  const currentTheme = mounted ? (theme === 'system' ? systemTheme : theme) : 'light';
  
  const logos = {
    dark: {
      full: '/GreenLogo.png',
      icon: '/IconGreen.png'
    },
    light: {
      full: '/BlackLogo.png',
      icon: '/IconBlack.png'
    }
  };

  // Show a placeholder or default logo during SSR and initial mount
  if (!mounted) {
    return (
      <div 
        className="cursor-pointer" 
        onClick={() => router.push('/')}
      >
        <Image
          src={logos.light.full}
          alt="Logo"
          width={collapsed ? 40 : 150}
          height={collapsed ? 40 : 30}
          className="object-contain"
          priority
        />
      </div>
    );
  }

  return (
    <div 
      className="cursor-pointer" 
      onClick={() => router.push('/')}
    >
      <Image
        src={currentTheme === 'dark' 
          ? (collapsed ? logos.dark.icon : logos.dark.full)
          : (collapsed ? logos.light.icon : logos.light.full)
        }
        alt="Logo"
        width={collapsed ? 40 : 150}
        height={collapsed ? 40 : 30}
        className="object-contain"
        priority
      />
    </div>
  );
} 